<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="tableHeader"
        :items="tableRows"
        :search="search"
        :options.sync="options"
        :server-items-length='totalItens'
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="newRowmodalButtonText" @click="emitDataTableNewRowEvent">
              {{ newRowmodalButtonText }}
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.descricaoIndicadorStatus`]="{ item }"> <!--- Trecho específico para tratamento da descrição de Status dos chamados e ordens de serviço --->
          <v-chip :color="getColor(item.descricaoIndicadorStatus)" dark>
            {{ item.descricaoIndicadorStatus }}
          </v-chip>
        </template>

        <template v-slot:[`item.tarefa.statusTarefa`]="{ item }"> <!--- Trecho específico para tratamento da descrição de Status da tarefa --->
          {{ formatarIcStatusTarefa(item.tarefa.statusTarefa) }}
        </template>

        <template v-slot:[`item.tarefa.tipoTarefa`]="{ item }"> <!--- Trecho específico para tratamento do tipo tarefa --->
          {{ formatarTipoTarefa(item.tarefa.tipoTarefa) }}
        </template>

        <template v-slot:[`item.tarefa.dataTarefa`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ _formatStringInBrazilianDateFormat(item.tarefa.dataTarefa) }}
        </template>

        <template v-slot:[`item.tarefa.dataCriacaoTarefa`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ _formatStringInBrazilianDateFormat(item.tarefa.dataCriacaoTarefa) }}
        </template>

        <template v-slot:[`item.tarefa.dataConclusaoTarefa`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ _formatStringInBrazilianDateFormat(item.tarefa.dataConclusaoTarefa) }}
        </template>

        <template v-slot:[`item.tarefaGerada.tarefa.dataTarefa`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ _formatStringInBrazilianDateFormat(item.tarefaGerada.tarefa.dataTarefa) }}
        </template>

        <template v-slot:[`item.licenca.dataVencimento`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ _formatStringInBrazilianDateFormat(item.licenca.dataVencimento) }}
        </template>

        <template v-slot:[`item.dataCriacao`]="{ item }"> <!--- Trecho específico para formatar data para pt-BR --->
          {{ _formatStringInBrazilianDateFormat(item.dataCriacao) }}
        </template>

        <template v-slot:[`item.endereco.nomeResponsavel`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ formatarNomeResponsavel(item.endereco.nomeResponsavel) }}
        </template>

        <template v-slot:[`item.tarefaGerada.endereco.nomeResponsavel`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ formatarNomeResponsavel(item.tarefaGerada.endereco.nomeResponsavel) }}
        </template>

        <template v-slot:[`item.solicitacao.indicadorTipo`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ formatarTipoSolicitacao(item.solicitacao.indicadorTipo) }}
        </template>

        <template v-slot:[`item.solicitacao.indicadorStatus`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ formatarIcStatusSolicitacao(item.solicitacao.indicadorStatus) }}
        </template>

        <template v-slot:[`item.tarefaGerada.tarefa.statusTarefa`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ formatarIcStatusTarefa(item.tarefaGerada.tarefa.statusTarefa) }}
        </template>

        <template v-slot:[`item.logSistema.numeroModel`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ formatarNumeroModel(item.logSistema.numeroModel) }}
        </template>

        <template v-slot:[`item.logSistema.dataCriacaoLog`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          {{ _formatStringInBrazilianDateFormat(item.logSistema.dataCriacaoLog) }}
        </template>

        <template v-slot:[`item.logSistema.indicadorTipoLog`]="{ item }"> <!--- Trecho específico para tratamento de mascara para data --->
          <v-chip :color="getColorTipoLog(item.logSistema.indicadorTipoLog)" dark>
            {{ formatarIcStatusLog(item.logSistema.indicadorTipoLog) }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{item}">
          <v-tooltip v-if=" isTarefa &&item.tarefa.statusTarefa == 1" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableFinishRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-check-circle
              </v-icon>
            </template>
            <span>Concluir</span>
          </v-tooltip>

          <v-tooltip v-if="isConfirmMaterial && item.statusMaterial === 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"        @click="emitMaterialRetiradoEvent(item)" v-bind="attrs" v-on="on">
                mdi-check-circle
              </v-icon>
            </template>
            <span>Confirmar Retirada de Itens</span>
          </v-tooltip>

          <v-tooltip v-if="isFinish && item.statusChamado != 0 && item.statusChamado != 8 && item.statusChamado != 7 && item.statusChamado != 3  " bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"        @click="emitDataTableFinishRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-check-circle
              </v-icon>
            </template>
            <span>Finalizar</span>
          </v-tooltip>

          <v-tooltip v-if="item.indicadorStatus != 8 && isEdit && item.indicadorStatusSolicitarItem != 'Comprado' && item.indicadorStatusSolicitarItem != 'Em processo de compras'" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableUpdateRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip v-if="isAddNewTarefa" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableUpdateRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-plus-circle
              </v-icon>
            </template>
            <span>Gerar nova Tarefa</span>
          </v-tooltip>
          
          <v-tooltip v-if="isEndereco" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableEnderecoRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-navigation
              </v-icon>
            </template>
            <span>Endereços</span>
          </v-tooltip>

          <v-tooltip v-if="item.indicadorStatus != 8 && isView " bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableViewRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-eye
              </v-icon>
            </template>
            <span>Visualizar</span>
          </v-tooltip>

          <v-tooltip v-if="isHistorico" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableHistoricoTarefa(item)" v-bind="attrs" v-on="on">
                mdi-book-open-page-variant
              </v-icon>
            </template>
            <span>Historico da Tarefa</span>
          </v-tooltip>

          <v-tooltip v-if="item.indicadorStatus != 8 && isStatus " bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2"  @click="emitDataTableUpdateStatusRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-flag-variant
              </v-icon>
            </template>
            <span>Atualizar Status</span>
          </v-tooltip>

          <v-tooltip v-if="isPrint" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTablePrintEvent(item)" v-bind="attrs" v-on="on">
                mdi-printer
              </v-icon>
            </template>
            <span>Imprimir</span>
          </v-tooltip>

          <v-tooltip v-if="isArquivo" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableArquivoEvent(item)" v-bind="attrs" v-on="on">
                mdi-file-download
              </v-icon>
            </template>
            <span>Gerar Arquivos</span>
          </v-tooltip>

          <v-tooltip v-if="isReport" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableGenerateReport(item)" v-bind="attrs" v-on="on">
                mdi-clipboard-arrow-up
              </v-icon>
            </template>
            <span>Gerar Relatório</span>
          </v-tooltip>

          <v-tooltip v-if="isDel && item.indicadorStatusSolicitarItem != 'Comprado' && item.indicadorStatusSolicitarItem != 'Em processo de compras'"  bottom > 
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableDeleteRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>

          <v-tooltip v-if="isRemove" bottom > 
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableRemoveRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
            
          <v-tooltip v-if="isContext && item.indicadorStatusManutencao == 1 && item.statusChamado != 0 && item.statusChamado != 8 && item.statusChamado != 7 && item.statusChamado != 3"  bottom >
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableContextRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-flag-variant
              </v-icon>
            </template>
            <span>Contestar O.S</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    tableTitle: String,
    newRowmodalButtonText: String,
    tableHeader: Array,
    tableRows: Array,
    isEdit: Boolean,
    isAddNewTarefa: Boolean,
    isView: Boolean,
    isStatus: Boolean,
    isHistorico: Boolean,
    isFinish: Boolean,
    isDel: Boolean,
    isRemove: Boolean,
    isPrint: Boolean,
    isArquivo: Boolean,
    isReport: Boolean,
    isContext: Boolean,
    isEndereco: Boolean,
    isConfirmMaterial: Boolean,
    isTarefa: Boolean,
    totalItens: Number
  },

  data: function() {
    return {
      search: "",
      options: {
        itemsPerPage: 10
      }
    };
  },

  
  watch: {
    options: {
      handler () {
        this.$emit("datatable-update-page", this.options);
      },
      deep: true
    },
    search(){
      this.$emit("datatable-update-search", this.search);
    }
  },

  methods: {
    _formatStringInBrazilianDateFormat(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
      } else {
        return "Sem Data";
      }
    },

    formatarNomeResponsavel(item) {
      switch (item) {
        case null: return "Não Informado"
      }
    },

    formatarTipoSolicitacao(item) {
      switch (item) {
        case 0:
          return "AIP";
        case 1:
          return "AIF";
      }
    },

    formatarNumeroModel(numero) {
      switch (numero) {
        case 1:
          return "Usuários";
        case 2:
          return "Nível";
        case 3:
          return "Permissão";
        case 4:
          return "Permissão Nível";
        case 5:
          return "Empresa";
        case 6:
          return "Endereço Empresa";
        case 7:
          return "Cnae";
        case 8:
          return "Categoria Cnae";
        case 9:
          return "Cnae Empresa";
        case 10:
          return "Roteiro";
        case 11:
          return "Setor Roteiro";
        case 12:
          return "Questão Setor";
        case 13:
          return "Alternativa Questão";
        case 14:
          return "Tarefa Roteiro";
        case 15:
          return "Resposta Alternativa Tarefa";
        case 16:
          return "Solicitação Tarefa";
        case 17:
          return "Item";
        case 18:
          return "Itens Solicitação";
        case 19:
          return "Foto Questão Setor";
        case 20:
          return "Roteiro Cnae";
        case 21:
          return "Resposta Questão Tarefa";
        case 22:
          return "Licença Endereço";
        case 23:
          return "Questão Solicitação Tarefa";
        case 24:
          return "Log Sistema";
      }
    },

    formatarIcStatusTarefa(item) {
      switch (item) {
        case 0:
          return "Em andamento";
        case 1:
          return "Concluido";
        case 2:
          return "Adiada";
        case 3:
          return "Concluido";
        case 4: 
          return "Processo Aberto";
        case 5:
          return "Concluido com Atraso";
      }
    },

    formatarIcStatusLog(item) {
      switch (item) {
        case 0:
          return "Erro";
        case 1:
          return "Sucesso";
      }
    },

    formatarIcStatusSolicitacao(item) {
      switch (item) {
        case 0:
          return "Aguardando Aprovação";
        case 1:
          return "Aprovado";
        case 2:
          return "Recusado";
      }
    },

    formatarTipoTarefa(item) {
      switch (item) {
        case 0:
          return "Tarefa";
        case 1:
          return "Denúncia";
        case 2:
          return "Retorno";
      }
    },

    emitMaterialRetiradoEvent(row) {
      this.$emit("datatable-retire", row);
    },

    emitDataTableNewRowEvent() {
      this.$emit("datatable-newrow");
    },

    emitDataTableContextRowEvent(row) {
      this.$emit("datatable-context", row);
    },

    emitDataTableUpdateRowEvent(row) {
      this.$emit("datatable-updaterow", row);
    },

    emitDataTableViewRowEvent(row) {
      this.$emit("datatable-viewrow", row);
    },

    emitDataTableHistoricoTarefa(row){
      this.$emit("datatable-historicotarefa", row)
    },

    emitDataTableUpdateStatusRowEvent(row){
      this.$emit("datatable-updatestatusrow", row)
    },

    emitDataTableDeleteRowEvent(row) {
      this.$emit("datatable-deleterow", row);
    },

    emitDataTableRemoveRowEvent(row){
      this.$emit("datatable-removerow", row)
    },

    emitDataTableFinishRowEvent(row){
      this.$emit("datatable-finishrow", row)
    },

    emitDataTablePrintEvent(row) {
      this.$emit("datatable-print", row);
    },

    emitDataTableArquivoEvent(row) {
      this.$emit("datatable-arquivo", row);
    },

    emitDataTableGenerateReport(row) {
      this.$emit("datatable-report", row);
    },

    emitDataTableEnderecoRowEvent(row) {
      this.$emit("datatable-endereco", row);
    },

    /**
     * @name getColor
     * @description Função especifica para uso em estruturas de dados de chamado e ordens de serviço.
     * Ela verifica o status da o.s/chamado e retorna uma cor específica para cada status
     * @returns {String} Nome da cor
     */
    getColorTipoLog(status) {
      if (status === 1) {
        return "green";
      }
      if (status === 0) {
        return "red";
      }
    },
  },
};
</script>
